module.exports = __webpack_public_path__ + "static/media/highlight.5623e7a9.jpg";